module.exports = __webpack_public_path__ + "rmts.png?e68834db6eab8309bed2acc5ebee01b5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rmts.png
// module id = 628
// module chunks = 0